import { useTranslation } from "react-i18next";

import styles from "./empty-404.module.css";
import { ASSETS_URL } from "@commons-monorepo/index";

const EmptyState404 = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.empty404container} role='not-found'>
      <div className={styles.content}>
        <div>
          <p className={styles.title}>{t("emptyState.404_title")}</p>
          <hr />
        </div>
        <img
          className={styles.emptyImg}
          src={`${ASSETS_URL}/prod/coupon-templates/empty-state-sumer.webp`} />

        <p className={styles.results}>{t("emptyState.not_results")}</p>
      </div>
    </div>);

};

export default EmptyState404;